import UserConsoleLayout from '@/views/kpi/layout/userConsoleLayout.vue';

/**
 * @import {Route} from "./route.jsdoc.js"
 */

/**
 * 企业用户公共路由表
 * @type {[Route]}
 */
export const enterpriseCommonRoutes = [
    {
        title: '首页',
        path: '/home',
        page: () => import('@/views/kpi/enterprise/home.vue'),
        layout: [ UserConsoleLayout ],
        visible: true,
        closable: false,
        requireAuth: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        menu: [ '首页' ],
        icon: 'vxe-icon-home',
    },
    {
        title: '账号安全设置',
        path: '/account/security-setting',
        page: () => import('@/views/common/account/security-config/security-config.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-admin', 'org-creator' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '账号', '账号安全设置' ],
        icon: [ 'vxe-icon-user', '' ],
        menuOrder: 1,
    },
    {
        title: '退出组织单位中心',
        path: `/enterprise/org-logout`,
        page: () => import('@/views/common/account/org-sign-out/org-sign-out.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-admin', 'org-creator' ],
        requireAuth: true,
        visible: false,
        closable: false,
    },
    {
        path: '/account/org-base-info',
        page: () => import('@/views/common/account/org-base-info/org-base-info.vue'),
        layout: [ UserConsoleLayout ],
        title: '组织单位信息',
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '账号', '组织单位信息' ],
        icon: [ 'vxe-icon-user', '' ],
    },
    {
        path: '/enterprise/sys-setting/my-org-list',
        page: () => import('@/views/kpi/my-org/my-org-list.vue'),
        layout: [ UserConsoleLayout ],
        title: '我的组织单位',
        roles: [ 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '部门管理',
        path: '/enterprise/sys-setting/org-dep-list',
        page: () => import('@/views/kpi/enterprise/my-org-dep/my-org-dep-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '系统设置', '部门管理' ],
        icon: [ 'vxe-icon-setting', '' ],
    },
    {
        title: '用户管理',
        path: '/enterprise/sys-setting/org-user-list',
        page: () => import('@/views/kpi/enterprise/my-org-user-list/my-org-user-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '系统设置', '用户管理' ],
        icon: [ 'vxe-icon-setting', '' ],
    },
    {
        title: '部门用户管理',
        path: '/enterprise/sys-setting/dep-user-list',
        page: () => import('@/views/kpi/enterprise/my-org-dep-user-list/my-org-dep-user-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效申报表',
        path: '/kpi/proj-kpi-audit/kpi-table-view/:projId',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/proj-kpi-table-view.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '项目绩效申报表',
        path: '/kpi/proj-kpi-audit/kpi-table/:projId',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/draft-kpi-table-view.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
];
